import React from 'react';
import { Flex } from '@fttb/common/components';
import { TariffCard as FttbTariffCard, TariffBenefitsGrid, TariffBenefitsItem, TariffBg, TariffGift, TariffImage, TariffLink, TariffName, TariffPrice, TariffTags, TariffValue, TariffValueGroupHeading, TariffValueGroups, TariffValues } from "../../../../../../blocks/TariffsBlock/components";
import { TariffButton } from "./components/TariffButton";
export var TariffCard = function TariffCard() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FttbTariffCard.Section, {
    overlay: /*#__PURE__*/React.createElement(TariffBg, {
      "data-t-id": "common-TariffCard"
    }, /*#__PURE__*/React.createElement(TariffImage, {
      "data-t-id": "common-TariffCard"
    })),
    side: "top"
  }, /*#__PURE__*/React.createElement(Flex, {
    className: "mar-b-s",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(TariffName, {
    "data-t-id": "common-TariffCard"
  }), /*#__PURE__*/React.createElement(TariffTags, {
    className: "mar-l-xs"
  })), /*#__PURE__*/React.createElement(TariffValueGroups, null, /*#__PURE__*/React.createElement(TariffValueGroupHeading, {
    className: "mar-b-xs",
    "data-t-id": "common-TariffCard"
  }), /*#__PURE__*/React.createElement(TariffValues, {
    className: "mar-b-xs"
  }, /*#__PURE__*/React.createElement(TariffValue, {
    className: "mar-b-2xs",
    "data-t-id": "common-TariffCard"
  })))), /*#__PURE__*/React.createElement(FttbTariffCard.Section, {
    side: "bottom"
  }, /*#__PURE__*/React.createElement(TariffBenefitsGrid, {
    className: "mar-b-m mar-t-2xs",
    wrap: "wrap"
  }, /*#__PURE__*/React.createElement(TariffBenefitsItem, {
    "data-t-id": "common-TariffCard"
  })), /*#__PURE__*/React.createElement(TariffLink, {
    className: "mar-b-s"
  }), /*#__PURE__*/React.createElement(TariffGift, {
    className: "mar-b-m"
  }), /*#__PURE__*/React.createElement(FttbTariffCard.Spacer, null), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    className: "mar-t-s",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(TariffPrice, {
    "data-t-id": "common-TariffCard"
  }), /*#__PURE__*/React.createElement(TariffButton, null))));
};